import React, { useMemo, useReducer } from "react";
import API from "../api/api";
import { useLocalStorage } from "../utils/useLocalStorage";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const initialState = { user: undefined, authenticated: undefined };

  // Local storage
  const [selectedUser, setSelectedUser] = useLocalStorage("selectedUser");

  const [state, dispatch] = useReducer((prevState, action) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case "SIGN_IN":
        return {
          user: action.user,
          authenticated: true,
        };
      case "SIGN_OUT":
        return {
          user: null,
          authenticated: false,
        };
    }
  }, initialState);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const value = useMemo(() => ({
    signIn: async (payload) => {
      const { data } = await API("POST", "/auth/login", payload);
      if (data) {
        dispatch({ type: "SIGN_IN", user: data });
        setSelectedUser(
          JSON.stringify({
            _id: data?.Account?._id,
            name: data?.Account?.name,
            role: data?.Account?.type,
            ...(data?.Account?.type === "operator" && {
              isBillingProfile: data?.Account?.isBillingProfile,
            }),
            ...(data?.Account?.type === "company" && {
              Operator: data?.Operator,
              currency: data?.currency,
            }),
          })
        );
      }
    },
    restoreSession: (payload) => {
      if (payload?.success) {
        dispatch({ type: "SIGN_IN", user: payload?.user });
      } else {
        dispatch({ type: "SIGN_OUT" });
        localStorage.clear();
      }
    },
    signOut: async () => {
      await API("POST", "/auth/logout");
      dispatch({ type: "SIGN_OUT" });
      localStorage.clear();
    },
  }));

  return (
    <AuthContext.Provider value={{ ...state, ...value }}>
      {children}
    </AuthContext.Provider>
  );
};
